export const BASE_URL =
  // "https://ugxrvgawcj.execute-api.eu-west-1.amazonaws.com/api/v1.0/location/delete-location";
  "https://mjqfhux23j.execute-api.eu-west-1.amazonaws.com/api/v1.0";

export const STAFF_ROLE = { 
  AttendanceHeads: 'attendance_heads',
  EmployeeHeads:'employee_heads',
  AttendanceTaker : 'attendance_taker',
  AddStaff:'add_staff',
  Unassigned:'unassigned',
  All:'all'
}
  
export const RULE_TYPE = {
  All_Future_Days: 'for_all_future_specific_day',
  This_Day: 'for_this_day',
  All_Future_Dates: 'for_all_future_dates',
}

export const GOOGLE_API_KEY = "AIzaSyAa-hWH7UHfBovlm4-VXIaBKEkQxb99Yrs";
export const LOGIN_ENDPOINT = "auth/signin";
export const LoginBoDetail = "auth/loginBoDetail";
export const SIGNUP_ENDPOINT = "auth/signup";
export const CHECKAUTH_ENDPOINT = "auth/index";
export const SEND_OTP_ENDPOINT = "auth/send-otp";
export const VERIFY_OTP_ENDPOINT = "auth/verify-otp";
export const VERIFY_SIGNUP_OTP_ENDPOINT = "auth/verify-signup";
export const UpdateLegalEntities = "auth/update-legal-entity";
export const UpdateBo = "auth/update-boOwner";
export const CompanyDropdownList = "common/dropdown-listing";
export const UploadFile = "common/upload-files";
export const AddLocation = "location/add-location";
export const FetchLocation = "location/location-listing";
export const DELETELocation = "location/delete-location";
export const UPDATELocation = "location/update-location";
export const AddDepartment = "department/addDepartment";
export const FetchDepartment = "department/getDepartmentList";
export const DeleteDepartment = "department/deleteDepartment";
export const UpdateDepartment = "department/updateDepartment";
export const AddSubDepartment = "department/addSubDepartment";
export const UpdateSubDepartment = "department/updateSubDepartment";
export const FetchDesignation = "designation/getDesignationList";
export const AddDesignation = "designation/addDesignation";
export const UpdateDesignation = "designation/updateDesignation";
export const DeleteDesignation = "designation/deleteDesignation";
export const AddShifts = "shift/add-shift";
export const FetchShifts = "shift/shift-listing";
export const UpdateShifts = "shift/update-shift";
export const DeleteShifts = "shift/delete-shift";
export const ShiftLogs = "shift/shift-logs";
export const AddShiftPlan = "shift/shift-plaining";
export const AddStaff = "staff/add-staff";
export const FetchStaff = "staff/staff-listing";
export const UpdateStaff = "staff/update-staff";
export const DeleteStaff = "staff/delete-staff";
export const OverviewStaff = "attendanceTracker/attendanceOverview";
export const structuredStaffListing = "staff/structured-staff-listing";
export const StaffRoleListEndPoint = "role/role-listing";
export const FetchAttendanceTodayView = "attendanceTracker/staffAttendanceTodayView";
export const FetchAttendanceDay = "attendanceTracker/staffAttendanceDay";
export const FetchAttendanceTimesheet = "attendanceTracker/staffAttendanceTimesheet";
export const FetchAttendanceCalendar = "attendanceTracker/attendanceCalendar";
export const FetchAttendanceSimpleView = "attendanceTracker/staffAttendanceSimpleView";
export const FetchAttendanceAlertView = "attendanceTracker/attendanceDailyWork";
export const UpdateBulkStaff = "staff/bulk-update";
